const selectors = {
  drawerToggle: '[data-quickadd-drawer-toggle]',
  drawerContent: '[data-quickadd-drawer-content]',
  quickAddElem: '[data-product-quickadd]',
  loader: '[data-quickadd-drawer-loader]',
};

const classes = {
  hide: 'hide',
};

function initQuickAddToggle(quickAddDrawer) {
  class QuickAddToggle extends HTMLElement {
    constructor() {
      super();

      this.quickAddDrawerToggle = this.querySelector(selectors.drawerToggle);
      this.drawerContent = quickAddDrawer.querySelector(selectors.drawerContent);
      this.loader = quickAddDrawer.querySelector(selectors.loader);

      this.rootUrl = window.theme.locale?.primary ? '' : window.theme.locale.rootUrl;

      // Initialise open / close functionality for quickadd drawer
      this.initDrawerToggle();
    }

    updateDrawerContent() {
      const productHandle = this.quickAddDrawerToggle?.dataset.productHandle;
      if (!productHandle) return;

      const modalHandle = this.drawerContent.dataset.modalContent ?? '';

      if (modalHandle === productHandle) return;

      // Reset content for modal and display loader
      if (this.drawerContent) {
        this.drawerContent.innerHTML = '';
        this.drawerContent.dataset.modalContent = '';
        this.loader.classList.remove(classes.hide);
      }

      // Fetch product details and update content for quickadd drawer
      const url = `${this.rootUrl}/products/${productHandle}?view=quickadd`;

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const parser = new DOMParser();
          const containerFetched = parser.parseFromString(responseText, 'text/html');
          const quickAddFetched = containerFetched.querySelector(selectors.quickAddElem);

          if (this.drawerContent) {
            this.drawerContent.innerHTML = quickAddFetched.outerHTML;
            this.drawerContent.dataset.modalContent = productHandle;
            this.loader.classList.add(classes.hide);
          }
        })
        .catch((error) => {
          window.console.error(error);
        });
    }

    initDrawerToggle() {
      this.quickAddDrawerToggle.addEventListener('click', () => {
        const isOpen = quickAddDrawer.classList.contains('is-hidden');
        quickAddDrawer.classList.toggle('is-hidden');
        quickAddDrawer.classList.toggle('is-visible');
        quickAddDrawer.setAttribute('aria-hidden', !isOpen);
        document.body.classList.toggle('quickadd-is-visible');

        const quickAddDrawerCloseButton = quickAddDrawer.querySelector('.side__drawer-close');
        quickAddDrawerCloseButton?.addEventListener('click', () => {
          this.quickAddDrawerToggle.focus();
        });

        // Fetch and update quickadd content
        this.updateDrawerContent();
      });
    }
  }

  customElements.define('quickadd-toggle', QuickAddToggle);
}

export default initQuickAddToggle;
